import { Component, OnInit, Inject, ViewChild, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { PropertyPanelDef } from 'src/app/_objects/interfaces/property-panel';
import { ListFormat, ReportTitleFormat } from 'src/app/_objects/report-template';
import { REGULAR_EXPRESSION } from 'src/app/app.constants';
import { UpdateMetadata } from 'src/app/_services/report-template-design.service';
import { ReportTemplateEditReportNameFormatDialogComponent } from '../report-template-edit-report-name-format-dialog/report-template-edit-report-name-format-dialog.component';
import { ListDialogComponent } from '../list-dialog/list-dialog.component';
import { REPORT_TEMPLATE___APPLICATION_TYPE, StorageService } from 'src/app/_services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from 'src/app/_services/lang-update.service';
import { CommonDeleteDialogComponent } from 'src/app/common-dialog/common-delete-dialog/common-delete-dialog.component';

@Component({
    selector: 'app-report-template-edit-property-dialog',
    styleUrls: ['./report-template-edit-property-dialog.component.scss'],
    templateUrl: './report-template-edit-property-dialog.component.html',
    standalone: false
})
export class ReportTemplateEditPropertyDialogComponent implements OnInit {

  propertyTableColumns = ['propertyValue'];
  commonPropPanels: PropertyPanelDef[];
  propertyPanels: string[] = [];
  selectedPanelId: string;
  selectedPanel: PropertyPanelDef;
  selectedTitleFormat: number;
  propertyPanelId = 'Property';
  reportNamePanelId = 'Report Name';
  listPanelId = 'List';
  formatModeControl = new UntypedFormControl('', [Validators.required]);
  formatModes = [
    { label: this.translate.instant('reporttemplateeditDialog.manual'), value: '0' },
    { label: this.translate.instant('reporttemplateeditDialog.auto'), value: '1' },
    { label: this.translate.instant('reporttemplateeditDialog.optional'), value: '2' },
  ];
  titleFormat: ReportTitleFormat[] = [];
  ListsFormat: ListFormat[] = [];
  isVisol = false;


  templateNameLength = 100;
  templateNameForm = new UntypedFormControl(null, [Validators.required, Validators.maxLength(this.templateNameLength),
  Validators.pattern(REGULAR_EXPRESSION.COMMONPATTERN)]);
  @ViewChild(MatSlideToggle, { static: true }) toggle: MatSlideToggle;

  @Output() changeCommonProp = new EventEmitter<UpdateMetadata>();
  @Output() changeTemplateName = new EventEmitter<string>();
  @Output() changeTemplateIsValid = new EventEmitter<boolean>();
  @Output() changeTemplateFormatMode = new EventEmitter<string>();
  @Output() changeTemplateTitleFormat = new EventEmitter<ReportTitleFormat[]>();
  @Output() changeLists = new EventEmitter<ListFormat[]>();
  @Output() selectedPanelName = new EventEmitter<string>();
  @ViewChild('templatecontent', { static: true }) templateContent;

  constructor(
    public dialogRef: MatDialogRef<ReportTemplateEditPropertyDialogComponent>,
    private dialog: MatDialog,
    private storageService: StorageService,
    private translate: TranslateService,
    private langService: LangUpdateService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.langService.prepare(this, this.translate, (res) => {
      this.formatModes[0].label = this.translate.instant('reporttemplateeditDialog.manual');
      this.formatModes[1].label = this.translate.instant('reporttemplateeditDialog.auto');
      this.formatModes[2].label = this.translate.instant('reporttemplateeditDialog.optional');
      });
  }

  ngOnInit() {
    const applicationType = this.storageService.fetchApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE);
    if (applicationType) {
      this.isVisol = applicationType.IsVisol;
    }
    this.commonPropPanels = this.data.commonPropPanels;
    this.selectedPanelId = this.propertyPanelId;
    this.propertyPanels.push(this.selectedPanelId, this.reportNamePanelId, this.listPanelId);
    this.commonPropPanels.forEach(panel => {
      this.propertyPanels.push(panel.title);
    });
    this.toggle.checked = this.data.templateIsValid;
    this.templateNameForm.setValue(this.data.templateName);
    this.formatModeControl.setValue(this.data.templateReportTitleInputMode);
    if (this.data.templateReportTitleFormat) {
      this.titleFormat = JSON.parse(JSON.stringify(this.data.templateReportTitleFormat));
    }
    this.selectedTitleFormat = null;
    if(this.data.templateList?.length > 0) {
      this.ListsFormat = this.data.templateList;
    }
  }
  
  onCommPropChange(data: UpdateMetadata) {
    this.selectedPanelName.emit(this.selectedPanelId);
    this.changeCommonProp.emit(data);
  }

  selectPanel(key: string) {
    this.templateContent.nativeElement.scrollIntoView();
    this.selectedPanelId = key;
    if (this.selectedPanelId !== this.propertyPanelId && this.selectedPanelId !== this.reportNamePanelId && this.selectedPanelId !== this.listPanelId) {
      this.selectedPanel = this.commonPropPanels.find((panel) => {
        return key === panel.title;
      });
    }
    this.changeDetectorRef.detectChanges();
  }

  selectTitleFormat(selectIndex: number) {
    this.selectedTitleFormat = selectIndex;
  }
  
  openEditFormatDialog(isEdit: boolean) {
    if (!isEdit) {
      const dialogRef = this.dialog.open(ReportTemplateEditReportNameFormatDialogComponent, {
        width: '600px',
        height: '380px',
        disableClose: true,
        data: {
          isEdit: false,
          formatItem: null
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.addTitleFormatItem(result);
        }
      });
    } else {
      const dialogRef = this.dialog.open(ReportTemplateEditReportNameFormatDialogComponent, {
        width: '600px',
        height: '380px',
        disableClose: true,
        data: {
          isEdit: true,
          formatItem: this.titleFormat[this.selectedTitleFormat]
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.editTitleFormatItem(result);
        }
      });
    }
  }

  openListDialog(isEdit: boolean, listData?:ListFormat, index?: number) {
    const dialogRef = this.dialog.open(ListDialogComponent, {
      width: '600px',
      height: '380px',
      disableClose: true,
      data: {
        isEdit: isEdit,
        formatItem: isEdit ? listData: null
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        isEdit === true ? this.addListFormatItem(result, index) : this.addListFormatItem(result) ;
      }
    });
  }

  deleteList(index: number){
    this.ListsFormat.splice(index, 1);
  }

  addListFormatItem(result: ListFormat, index?: number) {
    //const i = this.ListsFormat.findIndex(x => x.name == result.name);
    if(index > -1) {
      this.ListsFormat[index] = result;
    }
    else{
      this.ListsFormat.push(result);
    }
    this.onChangeAtList();
  }

  //Delete確認ダイアログ
  public deleteReportName(): void {
    let deleteNames: string;
    if (this.titleFormat[this.selectedTitleFormat].type === 'dynamic') {
      const reportNameKey = this.titleFormat[this.selectedTitleFormat].value;
      deleteNames = this.translate.instant('objects.' + reportNameKey);
    } else {
      deleteNames = this.titleFormat[this.selectedTitleFormat].value;
    }

    event.stopPropagation();
    const dialogRef = this.dialog.open(CommonDeleteDialogComponent, {
      width: '600px',
      minWidth: '400px',
      maxHeight: '800px',
      data: { target: this.translate.instant('reporttemplateeditDialog.reportName'), deleteNames: [deleteNames]}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteTitleFormatItem() ;
      }
    });
  }

  addTitleFormatItem(result: ReportTitleFormat) {
    this.titleFormat.push(result);
    this.selectedTitleFormat = this.titleFormat.length - 1;
    this.onChangeAtTemplateTitleFormat();
  }
  
  editTitleFormatItem(result: ReportTitleFormat) {
    this.titleFormat[this.selectedTitleFormat] = result;
    this.onChangeAtTemplateTitleFormat();
  }
  
  moveLeftTitleFormatItem() {
    const tempTitle = this.titleFormat[this.selectedTitleFormat];
    this.titleFormat[this.selectedTitleFormat] = this.titleFormat[this.selectedTitleFormat - 1];
    this.titleFormat[this.selectedTitleFormat - 1] = tempTitle;
    this.selectedTitleFormat--;
    this.onChangeAtTemplateTitleFormat();
  }
  
  moveRightTitleFormatItem() {
    const tempTitle = this.titleFormat[this.selectedTitleFormat];
    this.titleFormat[this.selectedTitleFormat] = this.titleFormat[this.selectedTitleFormat + 1];
    this.titleFormat[this.selectedTitleFormat + 1] = tempTitle;
    this.selectedTitleFormat++;
    this.onChangeAtTemplateTitleFormat();
  }
  
  deleteTitleFormatItem() {
    this.titleFormat.splice(this.selectedTitleFormat, 1);
    this.selectedTitleFormat = null;
    this.onChangeAtTemplateTitleFormat();
  }
  
  onChangeAtList() {
    this.changeLists.emit(this.ListsFormat);
  }
  
  onChangeAtTemplateName() {
    this.changeTemplateName.emit(this.templateNameForm.value);
  }
  
  onChangeAtTemplateIsValid() {
    this.changeTemplateIsValid.emit(this.toggle.checked);
  }
  
  onChangeAtTemplateFormatMode() {
    this.changeTemplateFormatMode.emit(this.formatModeControl.value);
  }
  
  onChangeAtTemplateTitleFormat() {
    this.changeTemplateTitleFormat.emit(this.titleFormat);
  }
  
  isDisableMoveLeftButton() {
    return this.selectedTitleFormat == null || this.selectedTitleFormat === 0;
  }
  
  isDisableMoveRightButton() {
    return this.selectedTitleFormat == null || this.selectedTitleFormat === this.titleFormat.length - 1;
  }
  
  isDisableEditButton() {
    return this.selectedTitleFormat == null;
  }
  
  isDisableDeleteButton(): boolean {
    return this.selectedTitleFormat == null;
  }
}
